import { module as BaseModule } from 'modujs';
import gsap from 'gsap';

import { html } from '../utils/dom';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        'nav-open': 'openNavigation',
        'user-access': 'openUserAccess',
        'lang-selector': 'toggleLanguageSelector',
      },
    };
  }

  openNavigation() {
    html.classList.add('has-menu-open', 'has-menu-visible', 'has-hscroll-disabled');
  }

  closeNavigation() {
    html.classList.remove('has-menu-open');
    setTimeout(() => {
      html.classList.remove('has-menu-visible', 'has-hscroll-disabled');
    }, 600);
  }

  openUserAccess() {
    this.call('open', 'UserAccess');
  }

  toggleLanguageSelector() {
    html.classList.toggle('has-language-selector-open');
  }

  runAnnouncementBar() {
    const announcements = this.$('announcements')[0];
    if (! announcements) {
      return;
    } else {
      document.documentElement.classList.add('has-announcements');
    }

    let listWidth = parseFloat( getComputedStyle( announcements ).width );
    let actualWidth = listWidth;

    //if ( listWidth < window.innerWidth ) {
    //  do {
    //    const clonedList = announcements.cloneNode( true );
    //    announcements.parentElement.appendChild( clonedList );
    //    actualWidth = parseFloat(
    //      getComputedStyle( announcements.parentElement ).width
    //    );
    //  } while ( actualWidth < window.innerWidth + listWidth );
    //} else {
    //  // list is long enough so we can clone and animate
    //  announcements.parentElement.appendChild( announcements.cloneNode( true ) );
    //}

    announcements.parentElement.classList.add('is-running');

    if ( listWidth > window.innerWidth ) {
      announcements.parentElement.appendChild( announcements.cloneNode( true ) );

      gsap.to( this.$('announcements'), {
        duration: Math.ceil( ( listWidth / 150 ) * 5 ),
        translateX: '-100%',
        repeat: -1,
        ease: 'linear'
      } );
    }
  }

  init() {
    this.runAnnouncementBar();

    gsap.fromTo( this.el.children[1], {
      //clipPath: 'inset(0 100% 0 0)'
      clipPath: 'inset(0 0 100%)'
    }, {
      duration: 1.6,
      delay: 0.0,
      ease: 'expo.inOut',
      //clipPath: 'inset(0 0% 0 0)',
      clipPath: 'inset(0 0 0%)',
      onComplete: () => {
        this.el.children[1].removeAttribute('style');
      }
    })
  }
}
